import {calculateMealMetrics, getRoundedCalculations} from "@client/calculations";
import {Card} from "@client/components/Card";
import {DaySummary} from "@client/components/DaySummary";
import {EntryCard} from "@client/components/EntryCard";
import {Flush} from "@client/components/Flush";
import {PieChart} from "@client/components/PieChart";
import * as forms from "@client/forms";
import * as typography from "@client/shared/typography";
import {ManagerLayout} from "@client/site/ManagerLayout";
import {reverse, server} from "@reactivated";
import React from "react";

import {ClientNavigation} from "./ClientManagerPlanner";

export const Template = (props: server.manager.templates.MealPlanDetail) => {
    const form = forms.useForm(props.form);
    const day = props.day;
    const useKilojoules = false;

    return (
        <ManagerLayout
            title={props.meal_plan.name ?? "Untitled plan"}
            narrow
            currentClientManagerId={null}
        >
            <form
                noValidate
                method="POST"
                action=""
                className="flex flex-col space-y-[15px]"
                onSubmit={forms.guard([form])}
            >
                <forms.CSRFToken />
                <ClientNavigation>
                    <typography.Header>{props.meal_plan.name}</typography.Header>
                    <typography.ButtonGroup>
                        <typography.Button href={`/journal/${props.meal_plan.id}/`}>
                            Modify
                        </typography.Button>
                        <typography.Button submit name="copy" value="">
                            Copy
                        </typography.Button>
                        <typography.Button
                            href={reverse("meal_plan_delete", {
                                meal_plan_id: props.meal_plan.id,
                            })}
                        >
                            Delete
                        </typography.Button>
                    </typography.ButtonGroup>
                </ClientNavigation>

                <Flush>
                    {day.meals.map((meal) => {
                        const calculations = getRoundedCalculations(
                            calculateMealMetrics(meal),
                            useKilojoules,
                        );

                        return (
                            <div key={meal.uuid}>
                                <Card
                                    item={meal}
                                    macros={calculations}
                                    hiddenMacros={false}
                                />
                                {meal.entries.map((entry) => (
                                    <EntryCard
                                        key={entry.uuid}
                                        indented
                                        entry={entry}
                                        hiddenMacros={false}
                                    />
                                ))}
                            </div>
                        );
                    })}
                    <div className="mx-4">
                        <DaySummary
                            useKilojoules={false}
                            day={day}
                            target={day.target}
                        />
                    </div>
                </Flush>
                <div style={{maxWidth: 400, height: 120, margin: "-10px auto"}}>
                    <PieChart {...props.status} />
                </div>
                <typography.Subheader>Settings</typography.Subheader>
                <forms.Form form={form} />
                <typography.Button submit>Submit</typography.Button>
            </form>
        </ManagerLayout>
    );
};
